module.exports = __webpack_public_path__ + "img/operational_monitoring_en.9dca68ef.svg";